import { render, staticRenderFns } from "./TrendReport.vue?vue&type=template&id=61b7bf09"
import script from "./TrendReport.vue?vue&type=script&lang=js"
export * from "./TrendReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports